import React, {useMemo} from 'react';
import {useSelector} from 'react-redux';

import {AccountLink} from 'src/components/links';

import {PLACE} from '../../constants';
import {
    userConferencesLicensedUsersDataSelector,
    userConferencesLicensedUsersResultSelector,
} from '../../slices/user-conferences-licensed-users.slice';

type Props = {
    accountId: number,
};

export const LicensedEnabledUsersCell = ({accountId}: Props) => {
    const {isLoading, loadingError} = useSelector(userConferencesLicensedUsersDataSelector);
    const result = useSelector(userConferencesLicensedUsersResultSelector);

    const count = useMemo(() => result?.data[accountId], [result, accountId]);

    if (isLoading || loadingError || !count) {
        return null;
    }

    return (
        <AccountLink
            accountId={accountId}
            place={PLACE}
            accountName={count.toString()}
            target="users-groups/licensed"
        />
    );
};
